import React from 'react';

import { useBooking } from '@/booking';
import { BookingRequest } from '@/booking/interfaces';
import { useHotel } from '@/hotel';
import { useTranslation } from '@/i18n';

import { ConfirmationHeader } from './ConfirmationHeader.component';

interface BookingConfirmationHeaderProps {
  bookingRequest: BookingRequest;
}

export const BookingConfirmationHeader: React.FC<
  BookingConfirmationHeaderProps
> = ({ bookingRequest }) => {
  const booking = useBooking(bookingRequest);
  const hotel = useHotel(bookingRequest.hotelSlug);
  const { t } = useTranslation(['confirmation']);

  if (!booking || !hotel) return null;

  return (
    <ConfirmationHeader
      title={t('confirmation:title', {
        city: hotel.location.address.city,
        name: hotel.name,
      })}
      subtitle={t('confirmation:subtitle')}
      confirmationMessage={t('confirmation:emailConfirmationMessage', {
        email: booking.firstRoomStay.billerProfile.email,
      })}
      headerImage={hotel.content.images.header}
    />
  );
};
